import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
//UI
import HomeLayout from '../../../layouts/HomeLayout';
import MainLoader from '../../../components/Loaders/MainLoader';
import BtnContent from '../../../components/buttons/BtnContent';
import HeaderForm from '../../../components/headers/catalogs/HeaderForm';
import Error from '../../../components/errors/Error';
import InputForm from '../../../components/Inputs/formInput/InputForm';
//SLICES
import { createDocumentThunk, updateDocumentThunk, getDocumentThunk, initialStateDocument } from '../../../store/slices/catalogs/documents.slice';

const DocumentationForm = () => {
    const { t } = useTranslation();
    let { document_id } = useParams();
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const { setValue, register, handleSubmit, formState: { errors } } = useForm();
    const { item, message, error } = useSelector(state => state.documents);
    const isLoading = useSelector(state => state.isLoadingSlice);

    useEffect(() => {
        if (document_id) {
            dispatch(getDocumentThunk(document_id));
        }
        return () => {
            dispatch(initialStateDocument());
        };
    }, []);

    useEffect(() => {
        setValue('name', item?.name)
    }, [item]);

    const onSubmit = (data) => {
        if (document_id) {
            dispatch(updateDocumentThunk(document_id, data));
        } else {
            dispatch(createDocumentThunk(data));
        }
    };

    if (message === "Registro creado correctamente " || message === "Registro actualizado correctamente ") {
        navigate(`/panel/documentations`);
    }

    return (
        <HomeLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className="w-[96%] mt-5 ml-5 ">
                    {error ? <Error state={error} /> : " "}
                    <HeaderForm title={document_id ? "Editar documento" : "Nuevo documento"} />
                    <div className='h-[90%]'>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className='flex gap-2 p-2'>
                                <InputForm
                                    spam={true}
                                    label={t("Nombre de documento")}
                                    input="input"
                                    type="text"
                                    cols={1}
                                    register={register("name", { required: true })}
                                    errors={errors.name && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
                            </div>                       
                            <div className="flex items-center justify-start py-5 gap-2 border-t-2 border-orange-500 mt-8">
                                <BtnContent type="submit">{t("save_button")}</BtnContent>
                                <BtnContent cancel={true} to={`/panel/documentations`}>{t("canceled_button")}</BtnContent>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default DocumentationForm;